module.exports = __webpack_public_path__ + "static/media/panasonicLogo.9d30abda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-screen/tech-logos/panasonicLogo.png
// module id = 499
// module chunks = 0